import { RightsDictionary } from '../contacts/rights';
import { rollbarLogger } from "./integrations/rollbarLogger";

interface ILogger {
    configure(options: LoggerConfigOptions): void;

    error(...args: any[]): void;
    warning(...args: any[]): void;
    info(...args: any[]): void;
    debug(...args: any[]): void;
}

export interface ILoggerIntegration extends ILogger {
    active(): boolean;
}

export type LoggerConfigOptions = {
    id: string;
    company: string;
    rights: RightsDictionary;
};

class GemLogger implements ILogger {

    private integrations: any[];

    constructor() {
        this.integrations = [];
        if (rollbarLogger.active()) {
            this.integrations.push(rollbarLogger);
        }
    }

    configure(options: LoggerConfigOptions) {
        this.integrations.forEach((i) => i.configure(options));
    }

    error(...args: any[]) {
        this.integrations.forEach((i) => i.error.apply(i, args));
    }

    warning(...args: any[]) {
        this.integrations.forEach((i) => i.warning.apply(i, args));
    }

    info(...args: any[]) {
        this.integrations.forEach((i) => i.info.apply(i, args));
    }

    debug(...args: any[]) {
        this.integrations.forEach((i) => i.debug.apply(i, args));
    }

}

export const logger = new GemLogger();



// WEBPACK FOOTER //
// ./_src/services/logging/loggingService.ts